import getBrowsingPlatform from "./getBrowsingPlatform";
import getCountryCode from "./getCountryCode";
import getPageLoadTimeFirstByte from "./getPageLoadTimeFirstByte";
import { getPreviousPageName } from "../../../../../services/analytics";
import getPageUrl from "./getPageUrl";
import getServer from "./getServer";
import getSiteContent1 from "./getSiteContent1";
import getSiteId from "./getSiteId";
import getVisitorType from "./getVisitorType";

const defaultState = () => ({
  globals: {
    browsingPlatform: getBrowsingPlatform(),
    countryCode: getCountryCode(),
    pageLoadTimeFirstByte: getPageLoadTimeFirstByte(),
    pageUrl: getPageUrl(),
    server: getServer(),
    siteContent1: getSiteContent1(),
    siteId: getSiteId(),
    visitorType: getVisitorType()
  },
  trackPage: {
    previousPageName: getPreviousPageName()
  }
});

export default defaultState;
